import React, { useEffect, useState } from 'react';
import { auth, db } from '../firebase/firebase-config';
import { doc, getDoc } from 'firebase/firestore';

const Legal = () => {
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const fetchUserData = async () => {
            const user = auth.currentUser;
            if (user) {
                const userRef = doc(db, 'users', user.uid);
                const userSnap = await getDoc(userRef);
                if (userSnap.exists()) {
                    setUserData(userSnap.data());
                }
            }
        };
        fetchUserData();
    }, []);

    return (
        <div className="flex justify-center items-center min-h-screen bg-[#020824] p-6">
            <div className="w-full max-w-2xl bg-white p-8 shadow-md rounded-lg border border-gray-200">
                <h2 className="text-2xl font-semibold text-gray-800 text-center mb-2">Meta Legal Assistance & Support</h2>
                <p className="text-gray-600 text-center text-sm mb-6">Your Trusted Legal Resource</p>

                {userData ? (
                    <>
                        <p className="text-gray-700 mb-4">Hello, <strong>{userData.firstName} {userData.lastName}</strong></p>
                        <p className="text-gray-700 mb-4">
                            If you require any legal assistance, clarification, or have inquiries related to compliance, 
                            policies, or account-related matters, our legal department is here to help. 
                            Please feel free to reach out for guidance and support.
                        </p>

                        <p className="text-gray-700 mb-4">
                            Our team is dedicated to ensuring transparency, fairness, and protection of rights. 
                            For any concerns or legal-related questions, do not hesitate to contact us.
                        </p>
                    </>
                ) : (
                    <p className="text-gray-600 text-center">No user signed in.</p>
                )}

                <p className="text-gray-800 font-semibold mt-6">Legal Contact:</p>
                <p className="text-gray-700">Barrister Maureen Louise<br />
                    Legal Head, Compliance & Advisory Team<br />
                    Email: <a href="mailto:mrsmaureenlouise@gmail.com" className="text-blue-600 underline">mrsmaureenlouise@gmail.com</a>
                </p>
            </div>
        </div>
    );
};

export default Legal;
